import * as React from 'react';

import { rem } from '../../tokens/spacing';
import { ShellSidebarSlot } from './AppShell.styled';

/* ─────────────────────────── Types ──────────────────────────────────────── */

export interface AppShellSidebarProps {
  children: React.ReactNode;
  width?: string;
  collapsedWidth?: string;
  collapsed?: boolean;
  onToggle?: () => void;
  className?: string;
}

/* ─────────────────────────── Sentinel ───────────────────────────────────── */

const SIDEBAR_SYMBOL = Symbol.for('AppShell.Sidebar');

/* ─────────────────────────── Component ──────────────────────────────────── */

function AppShellSidebar(props: AppShellSidebarProps): JSX.Element {
  const {
    children,
    width = rem(240),
    collapsedWidth = rem(64),
    collapsed = false,
    className,
  } = props;

  const resolvedWidth = collapsed ? collapsedWidth : width;

  return (
    <ShellSidebarSlot $width={resolvedWidth} $collapsed={collapsed} className={className}>
      {children}
    </ShellSidebarSlot>
  );
}

AppShellSidebar.displayName = 'AppShell.Sidebar';

(AppShellSidebar as any).__SHELL_SIDEBAR__ = SIDEBAR_SYMBOL;

export { AppShellSidebar, SIDEBAR_SYMBOL };
